// PrivateRoute.js

import React from "react";
import { Navigate } from "react-router-dom";


const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (token) {
    return children;
  } else {
    alert("Please Login");
    return <Navigate to={"/login"} />;
  }
};

export default PrivateRoute;
